import styled from "styled-components";

const Header = styled.div`
  width: 100%;
  min-height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Title = styled.h1`
margin-top: 32px;
margin-bottom: 32px;
text-align: center;
& > span {
  color: red;
}
`;

export const PageHeader = () => {
  return (
    <Header>
      <Title>Minesweeper <span>Versus.</span></Title>
    </Header>
  );
};
